// extracted by mini-css-extract-plugin
export default {"facetSearchContainer":"facetSearchContainer---oHX0n","facetSearch":"facetSearch---Zd8A7","moreIcon":"moreIcon---eF8m7"};